
import { PJAxios, setOfflineBundles, useLanguage, usePJStore } from '@jaf/jaf-react-core';
import { AutoComplete } from 'primereact/autocomplete';
import { Button } from 'primereact/button';
import { Column } from 'primereact/column';
import { Dropdown } from 'primereact/dropdown';
import { InputText } from 'primereact/inputtext';
import { ProgressSpinner } from 'primereact/progressspinner';
import React, { useEffect, useState } from 'react';
import './AggiungiNodo.css';

import { Accordion, AccordionTab } from 'primereact/accordion';

import { Divider } from 'primereact/divider';
import { flushCache } from '../../../api/ChatbotApi';
import isfilled from '../../Utils';
import Faq from '../Faq/Faq';
import { DataTable } from 'primereact/datatable';


function AggiungiNodo(props) {

    const [bundle_it, setBundle_it] = useState("");
    const [bundle_en, setBundle_en] = useState("");
    const [bundle_it2, setBundle2_it] = useState("");
    const [bundle_en2, setBundle2_en] = useState("");
    const bundles = usePJStore((state) => state.i18n_bundles)
        
        const getTextByLang = (lang, key) => {
          return bundles?.[lang]?.[key]
        }

    const language = useLanguage();


    const [modifiedNodes, setModifiedNodes] = useState([]);

    const [filteredNodesFaq, setFilteredNodesFaq] = useState([]);
    const [filteredNodesDests, setFilteredNodesDests] = useState([]);
    const [filteredNodesTematiche, setFilteredNodesTematiche] = useState([]);

    const [selectedItem, setSelectedItem] = useState(null);
    const [selectedItemDests, setSelectedItemDests] = useState(null);
    const [selectedItemTematiche, setSelectedItemTematiche] = useState(null);

    const [selectedFaq, setSelectedFaq] = useState(null);

    const [myFaqs, setMyFaqs] = useState(props.myFaqs);

    const [questions, setQuestions] = useState(props.faqs);
    const [dests, setDests] = useState([]);
    const [tematiches, setTematiches] = useState([]);


    const [gruppo, setGruppo] = useState(null);
    const [gruppi, setGruppi] = useState(null);

    const [tematiche, setTematiche] = useState(null);
    const [selectedTematica, setSelectedTematica] = useState(null);



    const [position, setPosition] = useState(0);

    const [expandedRows, setExpandedRows] = useState(null);
    const [loading, setLoading] = useState(false);


    const [activeIndex, setActiveIndex] = useState(-1)

    const getText = usePJStore((state) => state.i18n_getText)
    const dbTest = usePJStore((state) => state.appInfo_dbTest);
    const { storage } = usePJStore((state) => state.storage)


    useEffect(() => {
        getGroups();
    }, []);

    useEffect(() => {
        if (gruppo != null && gruppo.tag == getText("ALL")) {
            setMyFaqs(props.myFaqs)
        } else if (gruppo != null) {
            var items = []

            props.myFaqs.forEach((myfaq) => {
                if (gruppo.tag == myfaq.extra_fields.gruppo) {
                    items.push(myfaq);
                }
            })

            setMyFaqs(items)
        }

    }, [gruppo]);

    const loadFaqs = () => {
        PJAxios().get('/chatbot/getFaqs/' + props.tematica.id_config).then((res) => {
            props.onFaqsLoaded(res)

        })
    }

    useEffect(() => {

        if (props.faqs == null || props.faqs.length == 0) {
            loadFaqs()
        }


    }, [props.selectedNode]);


    const iconScheduled = "pi pi-clock";
    const iconHidden = "pi pi-eye-slash";
    const iconVisible = "pi pi-eye";
    const iconExpired = "pi pi-exclamation-circle";

    useEffect(() => {

        let questions = [];
        let dests = [];
        let tematiches = [];

        if (props.dests != null) {
            props.dests.forEach((dest) => {

                let question = {
                    value: dest.id_item,
                    label: dest.label,
                    label_it: dest.label_it,
                    label_en: dest.label_en,
                    icon: "pi pi-envelope",
                    idItem: dest.idItem
                }
                dests.push(question);

            })
        }

        if (props.links != null) {
            props.links.forEach((link) => {
                if (link.icon === "pi pi-link") {
                    let question = {
                        value: link.key,
                        label: "" + link.label,
                        icon: link.icon
                    }
                    tematiches.push(question);
                } else if (link.icon === "emptyMenuIcon") {

                    link.children.forEach((inner) => {
                        if (inner.icon === "pi pi-link") {
                            let question = {
                                value: inner.key,
                                label: inner.label,
                                icon: inner.icon
                            }
                            tematiches.push(question);
                        }
                    })
                }

            })
        }

        setFilteredNodesFaq(props.faqs);
        setFilteredNodesDests(dests);
        setFilteredNodesTematiche(tematiches);


        setDests(dests);
        setTematiches(tematiches);

    }, [props.faqs]);

    useEffect(() => {
        if (props.root) {
            PJAxios().post('/gestioneConfigurazioni/elencoConfigurazioni', { refresh: true }).then((res) => {
                setTematiche(res.data);
            });
        }
    }, [props.root]);

    useEffect(() => {
        if (selectedItem != null && props.faqs != null && props.faqs.length > 0) {

            const faqDetail = props.faqs.filter((item => item.value == selectedItem.value))[0]
            if (faqDetail != null && faqDetail.value != null) {
                setSelectedFaq(faqDetail);
            }

        }

    }, [selectedItem]);

    const salvaTutto = () => {

        setLoading(true);

        PJAxios().post('/gestioneConfigurazioni/salvaTutto', { operazioni: modifiedNodes, idConfig: props.tematica.id_config }).then((res) => {
            props.onSave(props.tematica, true);
            setModifiedNodes([]);
            flushCache(dbTest);
        }).finally(() => {
            setLoading(false)
        });
    }

    const salvaMenu = () => {

        setLoading(true);

        PJAxios().post('/gestioneConfigurazioni/salvaTutto', { operazioni: modifiedNodes, idConfig: props.tematica.id_config }).then((res) => {
             //console.log("res", res)
            let title = "M_" + res.data.idItem + ":TITLE";

            setOfflineBundles({
                it: {
                    [title]: bundle_it
                }, en: {
                    [title]: bundle_en
                }
            })
            title = "M_" + res.data.idItem + ":SUBTITLE";
            setOfflineBundles({
                it: {
                    [title]: bundle_it2
                }, en: {
                    [title]: bundle_en2
                }
            })

            props.onSave(props.tematica, true);
            setModifiedNodes([]);
            flushCache(dbTest);
        }).finally(() => {
            setLoading(false)
        });
    }

    const aggiungiTematica = () => {
        let position = props.root ? props.rootChilds : props.selectedNode.children != null ? props.selectedNode.children.length : 0
        var item = {
            is_new: true,
            id_tree: "jstree_tematica",
            obj_type: "itemLink",
            op_type: "add_br",
            position: position == null ? 0 : position,
            id_item_parent: 0,
            id_item: selectedTematica,
            id_node_parent: 0,
            bundle_en: bundle_en,
            bundle_it: bundle_it
        }
        modifiedNodes.push(item)
        setModifiedNodes(modifiedNodes)

        salvaTutto();
    }

    const aggiungiMenu = () => {

        let position = props.root ? props.rootChilds : props.selectedNode.children != null ? props.selectedNode.children.length : 0

        var item = {
            is_new: true,
            id_tree: "jstree_tematica",
            obj_type: "menu",
            op_type: "add_br",
            position: position == null ? 0 : position,
            id_item_parent: 0,
            id_item: 0,
            id_node_parent: 0,
            bundle_en: bundle_en,
            bundle_it: bundle_it,
            bundle_en2: bundle_en2,
            bundle_it2: bundle_it2

        }
        modifiedNodes.push(item)
        setModifiedNodes(modifiedNodes)

        salvaMenu();
    }

    const aggiungiSottoMenu = () => {

        var item = {
            is_new: true,
            id_tree: "jstree_tematica",
            obj_type: "menu",
            op_type: "add_br",
            position: props.selectedNode.children.length,
            id_item_parent: props.selectedNode.idItem,
            id_item: 0,
            id_node_parent: props.selectedNode.idNode,
            bundle_en: bundle_en,
            bundle_it: bundle_it,
            bundle_en2: bundle_en2,
            bundle_it2: bundle_it2
        }
        modifiedNodes.push(item)
        setModifiedNodes(modifiedNodes)

        salvaMenu();


    }

    const aggiungiNodo = (i) => {

        var item = {
            id_item: i.idItem,
            id_item_parent: props.selectedNode.idItem,
            id_node_parent: props.selectedNode.idNode,
            id_tree: "jstree_tematica",
            is_new: true,
            new_val: i.label,
            obj_type: i.icon === 'pi pi-link' ? "itemLink" : "itemFaq",
            op_type: "copy",
            position: position
        }

        modifiedNodes.push(item)
        setModifiedNodes(modifiedNodes)

        salvaTutto();
    }


    const aggiungiNodoDaInput = (idItem) => {
        var item = {

            id_item: idItem,
            id_item_parent: props.selectedNode.idItem,
            id_node_parent: props.selectedNode.idNode,
            id_tree: "jstree_tematica",
            is_new: false,
            new_val: props.selectedNode.title,
            obj_type: "itemFaq",
            op_type: "copy",
            position: position

        }

        modifiedNodes.push(item)
        setModifiedNodes(modifiedNodes)

        salvaTutto();
    }


    const searchNode = (event) => {

        setTimeout(() => {
            var ret = [];
            questions.forEach((node) => {
                if (getTextByLang("it",node.question).toLowerCase().indexOf(event.query.toLowerCase()) !== -1 ||
                    getTextByLang("en",node.question).toLowerCase().indexOf(event.query.toLowerCase()) !== -1 ||
                    getTextByLang("it",node.answer).toLowerCase().indexOf(event.query.toLowerCase()) !== -1 ||
                    getTextByLang("en",node.answer).toLowerCase().indexOf(event.query.toLowerCase()) !== -1
                ) {
                    ret.push(node);
                }
            })
            setFilteredNodesFaq(ret);
        }, 250);

    }

    const searchNodeDests = (event) => {
        setTimeout(() => {
            var ret = [];
            dests.forEach((node) => {
                if (getText(node.label).toLowerCase().indexOf(event.query.toLowerCase()) !== -1) {

                    let question = {
                        label: node.label,
                        label_en: node.label_en,
                        label_it: node.label_it,
                        value: node.value,
                        icon: node.icon,
                        idItem: node.idItem

                    }

                    ret.push(question);
                }
            })
            setFilteredNodesDests(ret);
        }, 250);

    }

    const searchNodeTematiche = (event) => {
        setTimeout(() => {
            var ret = [];
            tematiches.forEach((node) => {
                if (node.label.toLowerCase().indexOf(event.query.toLowerCase()) !== -1) {

                    let question = {
                        label: node.label,
                        value: node.value,
                        icon: node.icon

                    }

                    ret.push(question);
                }
            })
            setFilteredNodesTematiche(ret);
        }, 250);

    }

    const selezionaFaq = (rowData) => {
        aggiungiNodoDaInput(rowData.idItem);
    }

    const groupItemTemplate = (item) => {
        return (
            <div >
                <div className="formgroup-inline col-12 md:col-12">
                    <div>{item.tag}</div>
                </div>
            </div>
        )
    }

    const destItemTemplate = (item) => {
        return (

            <div >
                <div className="formgroup-inline col-12 md:col-12">
                    <div className="col-2 md:col-2">
                        <i className={item.icon}></i>
                    </div>
                    <div className="col-10 md:col-10">
                        <div>{getText(item.label)}</div>
                    </div>
                </div>


            </div>
        )
    }

    const itemTemplate = (item) => {
        return (

            <div >
                <div className="formgroup-inline col-12 md:col-12">
                    <div className="col-2 md:col-2">
                        <i className={item.icon}></i>
                    </div>
                    <div className="col-10 md:col-10">
                        <div>{item.label}</div>
                    </div>
                </div>


            </div>
        )
    }

    const actionBodyTemplate = (rowData) => {
        return (
            <div >
                <div className="formgroup-inline col-12 md:col-12">
                    {/*<div className="col-2 md:col-4"><Button className='p-button-secondary' icon="pi pi-pencil" onClick={() => { modificaFaq(rowData) }}></Button></div>
                    <di className="col-2 md:col-4"><Button className='p-button-danger' icon="pi pi-trash" onClick={() => { cancellaFaq(rowData) }}></Button></div>*/}
                    <div className="col-2 md:col-4"><Button className='p-button-primary' icon="pi pi-plus" label={getText("AGGIUNGI")} onClick={() => { selezionaFaq(rowData) }}></Button></div>
                </div>
            </div>

        );
    }

    const rowExpansionTemplate = (data) => {
        return (
            <div className="formgroup-inline col-12 md:col-12">
                <div className="col-6 md:col-6">

                    <div className="col-12 md:col-12" dangerouslySetInnerHTML={{ __html: data.extra_fields.risposta_it }}>
                    </div>
                </div>

                <div className="col-6 md:col-6">
                    <div className="col-12 md:col-12" dangerouslySetInnerHTML={{ __html: data.extra_fields.risposta_en }}>
                    </div>
                </div>
            </div>
        );
    }


    const validateForm = () => {
        return isfilled(bundle_en) && isfilled(bundle_it) && !isfilled(bundle_en2) && !isfilled(bundle_it2) || isfilled(bundle_en) && isfilled(bundle_it) && isfilled(bundle_en2) && isfilled(bundle_it2);
    }

    function autocompleteDisabled(item) {
        return item == null || !item.hasOwnProperty("label")
    }

    const searchGroup = (event) => {
        setTimeout(() => {
            var ret = [];
            gruppi.forEach((item) => {
                if (item.tag.toLowerCase().indexOf(event.query.toLowerCase()) !== -1) {

                    let question = {
                        tag: item.tag,
                        conteggio: item.conteggio
                    }

                    ret.push(question);
                }
            })
            setGruppi(ret);
        }, 250);

    }

    const getGroups = () => {
        PJAxios().post('/gestioneConfigurazioni/getGroups', { type: "Q" }).then((res) => {

            let items = res.data;
            items.unshift({ tag: getText("ALL"), conteggio: 0, filter: false })

            setGruppi(items);
            setGruppo({ tag: getText("ALL"), conteggio: 0, filter: false });
        });
    }


    const onFaqCreated = (idItem, addToTree) => {
        if (addToTree) {
            aggiungiNodoDaInput(idItem)
        }
        loadFaqs();
        props.onFaqCreated();
    }

    return (
        <>
            {loading &&
                <ProgressSpinner />
            }

            {!loading &&
                <>
                    {props.root &&
                        <>

                            <span style={{ textAlign: "left", textTransform: "uppercase" }}><h6><b>{getText("INSERISCI_MENU")}</b></h6></span>

                            <p style={{ textAlign: "left" }}>{getText("INSERISCI_MENU_SUBTITLE")}</p>
                            <br />
                            <div className="p-fluid grid">
                                <div className="field col-12 md:col-6">
                                    Testo in Italiano
                                    <InputText placeholder={getText("SCRIVI_QUALCOSA")} className="width500px p-inputtext-sm block mb-2 " id="menu" value={bundle_it} onChange={(e) => setBundle_it(e.target.value)} />
                                </div>
                                <div className="field col-12 md:col-6">
                                    Testo in Inglese
                                    <InputText placeholder={getText("SCRIVI_QUALCOSA")} className="width500px p-inputtext-sm block mb-2 " id="menu" value={bundle_en} onChange={(e) => setBundle_en(e.target.value)} />
                                </div>
                            </div>
                            <span style={{ textAlign: "left", textTransform: "uppercase" }}><h6><b>{getText("INSERISCI_MENU_DESCRIPTION")}</b></h6></span>

                            <p style={{ textAlign: "left" }}>{getText("INSERISCI_MENU_SUBTITLE_DESCRIPTION")}</p>
                            <br />
                            <div className="p-fluid grid">

                                <div className="field col-12 md:col-6">
                                    Testo in Italiano
                                    <InputText placeholder={getText("SCRIVI_QUALCOSA")} className="width500px p-inputtext-sm block mb-2 " id="menu" value={bundle_it2} onChange={(e) => setBundle2_it(e.target.value)} />
                                </div>
                                <div className="field col-12 md:col-6">
                                    Testo in Inglese
                                    <InputText placeholder={getText("SCRIVI_QUALCOSA")} className="width500px p-inputtext-sm block mb-2 " id="menu" value={bundle_en2} onChange={(e) => setBundle2_en(e.target.value)} />
                                </div>
                            </div>
                            <div className="p-fluid grid">
                                <div className="field col-12 md:col-3">
                                    <Button disabled={!validateForm()} onClick={aggiungiMenu} icon="pi pi-plus" label={getText("AGGIUNGI")} />
                                </div>
                            </div>

                            <br />
                            <br />
                            <span style={{ textAlign: "left", textTransform: "uppercase" }}><h6><b>{getText("COLLEGA_A_TEMATICA")}</b></h6></span>

                            <p style={{ textAlign: "left" }}>{getText("COLLEGA_A_TEMATICA_SUBTITLE")}</p>
                            <br />
                            <div className="col-12">
                                <Dropdown placeholder={getText("SELEZIONA_TEMATICA")} id="selectedTematica" value={selectedTematica} options={tematiche} onChange={(e) => {  console.log(e); setSelectedTematica(e.value) }} optionLabel="name" optionValue="id_config" />
                            </div>
                            <div className="p-fluid grid">
                                <div className="field col-12 md:col-3">
                                    <Button disabled={selectedTematica == null} onClick={aggiungiTematica} icon="pi pi-plus" label={getText("AGGIUNGI")} />
                                </div>
                            </div>

                        </>


                    }

                    {!props.root &&
                        <div className="card">
                            <div className="field col-12 md:col-12">

                                <Accordion activeIndex={activeIndex} onTabChange={(e) => setActiveIndex(e.index)}>

                                    <AccordionTab header={getText("CREA_E_AGGIUNGI_FAQ")}>
                                        <div className='surface-card' >
                                            <Faq createAndAdd onFaqCreated={onFaqCreated} gruppi={gruppi} isNew={true} allowDelete onSave={props.onSave} tematica={props.tematica} idConfig={props.tematica.id_config} selectedNode={props.selectedNode} />
                                            <br />
                                            <span className="p-fluid">

                                                <div className="p-fluid grid">
                                                    <div className="field col-12 md:col-12">
                                                        <Button icon="pi pi-plus" disabled={autocompleteDisabled(selectedItem)} label={getText("AGGIUNGI_NODO")} className="p-button-primary" onClick={() => aggiungiNodo(selectedItem)} />
                                                    </div>
                                                </div>

                                            </span>


                                        </div>
                                    </AccordionTab>

                                    <AccordionTab header={getText("FAQ_CATALOGO_OGGETTI")}>
                                        <div className='surface-card' >
                                            <span className="p-fluid">
                                                <AutoComplete field="tag" dropdown placeholder={getText("INSERISCI_GRUPPO_PLACEHOLDER")} value={gruppo} suggestions={gruppi} completeMethod={searchGroup} onChange={(e) => setGruppo(e.value)} itemTemplate={groupItemTemplate} />
                                            </span>
                                            <DataTable title={getText("YOUR_LIST")}
                                                expandedRows={expandedRows} onRowToggle={(e) => setExpandedRows(e.data)}
                                                rowExpansionTemplate={rowExpansionTemplate} dataKey="elemento_id"
                                                scrollable scrollHeight="400px" showGridlines size="small" stripedRows rows={100} value={myFaqs} responsiveLayout="scroll">

                                                <Column expander style={{ width: "10px" }} />
                                                <Column className="centeredColumn" field="domanda_it" tooltip="risposta_it" header={getText("DOMANDA_IT")}></Column>
                                                <Column className="centeredColumn" field="domanda_en" header={getText("DOMANDA_EN")}></Column>
                                                <Column className="centeredColumn" hidden field="risposta_it" header={getText("DOMANDA_EN")}></Column>
                                                <Column className="centeredColumn" hidden field="risposta_en" header={getText("DOMANDA_EN")}></Column>
                                                <Column body={actionBodyTemplate} header={getText("AZIONI")} exportable={false}></Column>
                                            </DataTable>
                                        </div>
                                    </AccordionTab>

                                    <AccordionTab header={getText("RICERCA_OGGETTO_FAQ")}>
                                        <div className='surface-card' >
                                            <p style={{ textAlign: "left" }}>{getText("RICERCA_OGGETTO_SUBTITLE")}</p>

                                            {selectedItem != null && selectedItem.value != null &&
                                                <>
                                                    <Divider />
                                                    <div className="formgroup-inline col-12 md:col-12" >
                                                        <div className="col-6" style={{ fontWeight: "bold" }} >
                                                            {getText("TESTO_IN_ITALIANO")}
                                                        </div>
                                                        <div className="col-6" style={{ fontWeight: "bold" }} >
                                                            {getText("TESTO_IN_INGLESE")}
                                                        </div>


                                                    </div>
                                                    <br />
                                                    <div className="formgroup-inline col-12 md:col-12" >
                                                        <div className="col-5 littleBox" dangerouslySetInnerHTML={{ __html: getTextByLang("it",selectedItem.answer) }}>

                                                        </div>
                                                        <div className="col-2 littleBox">
                                                            <Divider layout="vertical" className='littleBox' />
                                                        </div>

                                                        <div className="col-5 littleBox" dangerouslySetInnerHTML={{ __html: getTextByLang("en",selectedItem.answer) }}>

                                                        </div>
                                                    </div>
                                                    <Divider />
                                                </>
                                            }

                                            <span className="p-fluid">
                                                <AutoComplete
                                                    placeholder={getText("SCRIVI_QUALCOSA")}
                                                    field="label"
                                                    value={selectedItem}
                                                    suggestions={filteredNodesFaq}
                                                    completeMethod={searchNode} onChange={(e) => setSelectedItem(e.value)} onSelect={(e) => setSelectedItem(e.value)} itemTemplate={itemTemplate} />
                                            </span>

                                            <br />


                                            <>



                                                <span className="p-fluid">

                                                    <div className="p-fluid grid">
                                                        <div className="field col-12 md:col-12">
                                                            <Button icon="pi pi-plus" disabled={autocompleteDisabled(selectedItem)} label={getText("AGGIUNGI_NODO")} className="p-button-primary" onClick={() => aggiungiNodo(selectedItem)} />
                                                        </div>
                                                    </div>

                                                </span>
                                            </>

                                        </div>
                                    </AccordionTab>

                                    <AccordionTab header={getText("INSERISCI_MENU")}>
                                        <div className='surface-card' >
                                            <div className="p-fluid grid">
                                                <div className="field col-12 md:col-4">
                                                    {getText("TESTO_IN_ITALIANO")}
                                                    <InputText placeholder={getText("SCRIVI_QUALCOSA")} className="width500px p-inputtext-sm block mb-2 " id="menu" value={bundle_it} onChange={(e) => setBundle_it(e.target.value)} />
                                                </div>
                                                <div className="field col-12 md:col-4">
                                                    {getText("TESTO_IN_INGLESE")}
                                                    <InputText placeholder={getText("SCRIVI_QUALCOSA")} className="width500px p-inputtext-sm block mb-2 " id="menu" value={bundle_en} onChange={(e) => setBundle_en(e.target.value)} />
                                                </div>
                                                <div className="field col-12 md:col-2">
                                                    <Button onClick={aggiungiSottoMenu} icon="pi pi-plus" disabled={!validateForm()} label={getText("AGGIUNGI")}></Button>
                                                </div>

                                            </div>
                                        </div>
                                    </AccordionTab>





                                    <AccordionTab header={getText("RICERCA_OGGETTO_DESTS")}>
                                        <div className='surface-card' >
                                            <p style={{ textAlign: "left" }}>{getText("RICERCA_OGGETTO_SUBTITLE")}</p>
                                            <span className="p-fluid">
                                                <AutoComplete placeholder={getText("SCRIVI_QUALCOSA")} field={language == "IT" ? 'label_it' : 'label_en'} itemTemplate={destItemTemplate} value={selectedItemDests} suggestions={filteredNodesDests} completeMethod={searchNodeDests} onChange={(e) => setSelectedItemDests(e.value)} onSelect={(e) => setSelectedItemDests(e.value)} />

                                            </span>

                                            <br />
                                            <>


                                                <span className="p-fluid">

                                                    <div className="p-fluid grid">
                                                        <div className="field col-12 md:col-12">
                                                            <Button icon="pi pi-plus" disabled={autocompleteDisabled(selectedItemDests)} label={getText("AGGIUNGI_NODO")} className="p-button-primary" onClick={() => aggiungiNodo(selectedItemDests)} />
                                                        </div>
                                                    </div>

                                                </span>
                                            </>

                                        </div>
                                    </AccordionTab>


                                    <AccordionTab header={getText("RICERCA_OGGETTO_TEMATICA")}>
                                        <div className='surface-card' >
                                            <p style={{ textAlign: "left" }}>{getText("RICERCA_OGGETTO_SUBTITLE")}</p>
                                            <span className="p-fluid">
                                                <AutoComplete placeholder={getText("SCRIVI_QUALCOSA")} field="label" value={selectedItemTematiche} suggestions={filteredNodesTematiche} completeMethod={searchNodeTematiche} onChange={(e) => setSelectedItemTematiche(e.value)} onSelect={(e) => setSelectedItemTematiche(e.value)} itemTemplate={itemTemplate} />
                                            </span>

                                            <br />
                                            <>



                                                <span className="p-fluid">

                                                    <div className="p-fluid grid">
                                                        <div className="field col-12 md:col-12">
                                                            <Button icon="pi pi-plus" disabled={autocompleteDisabled(selectedItemTematiche)} label={getText("AGGIUNGI_NODO")} className="p-button-primary" onClick={() => aggiungiNodo(selectedItemTematiche)} />
                                                        </div>
                                                    </div>

                                                </span>
                                            </>

                                        </div>
                                    </AccordionTab>


                                </Accordion>

                            </div>
                        </div>
                    }
                </>
            }
        </>
    )
}

export default AggiungiNodo
